module.exports = __webpack_public_path__ + "img/fadergs.dfd254fc.svg";